import { useState } from 'react';

export const useShare = () => {
  const [sharing, setSharing] = useState(false);
  const [shareUrl, setShareUrl] = useState(null);

  const createShare = async (type, data) => {
    setSharing(true);
    setShareUrl(null);
    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      const res = await fetch(`${API}/api/shares`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, data })
      });
      const share = await res.json();
      const url = `${window.location.origin}?share=${share.id}`;
      setShareUrl(url);
      return url;
    } catch (e) {
      return null;
    } finally {
      setSharing(false);
    }
  };

  return { sharing, shareUrl, createShare };
};
